<template>
   <v-container>
       <v-row class="NotFoundContainer" align-center>
           <v-col>
               <h3>Die Seite konnte nicht gefunden werden</h3>
               <p>Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support</p>
           </v-col>
       </v-row>
   </v-container>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style lang="scss" scoped>
.NotFoundContainer {
    height: 100vh;
}
</style>
